import { FC } from 'react';
// Interfaces
import { IconSvgProps } from '@utmb/types/icons';

const MandatoryEquipmentCheck: FC<IconSvgProps> = ({ color, clss, width, height }) => {
    return (
        <svg className={clss} width={width} height={height} viewBox="0 0 42.39 43.45">
            <g>
                <g>
                    <rect fill={color} x="5.79" y="14.3" width="14.13" height="1.86"/>
                    <path fill={color} d="M39.83,17.4l-6.77,3.6V2.95h-9.17V0h-14.72v2.95H0v37.97l1.86-1.76V4.81h7.31v3.03h14.72v-3.03h7.31v17.19l-2.17,1.16.08-.11-1.51-1.1-2.34,3.21-.37.19-1.29-1.19-1.26,1.37.81.75-2.96,1.57c-.42.22-.79.53-1.09.9l-2.69,3.31-.98,1.41,1.69.11,4.21-.09c.56-.01,1.12-.16,1.61-.42l8.26-4.44v12.95H2.01l-1.97,1.86h33.02v-15.82l9.33-5.02-2.56-5.21ZM22.02,2.95v3.03h-10.99V1.86h10.99v1.08ZM22.05,31.43c-.24.13-.5.2-.77.2l-2.17.05,1.42-1.75c.14-.18.32-.32.52-.43l17.94-9.55.92,1.87-17.87,9.61Z"/>
                    <polygon fill={color} points="29.1 12.59 27.59 11.49 25.02 15.02 23.59 13.71 22.32 15.08 25.29 17.81 29.1 12.59"/>
                    <rect fill={color} x="5.79" y="24.75" width="14.13" height="1.86"/>
                    <rect fill={color} x="5.79" y="35.21" width="14.13" height="1.86"/>
                </g>
                <polygon fill={color} points="25.29 38.72 29.1 33.5 27.59 32.4 25.02 35.93 23.59 34.62 22.32 35.99 25.29 38.72"/>
            </g>
        </svg>
    );
};

export default MandatoryEquipmentCheck;
